<div class="section-header">
    <div class="title">
        {{getTitle()}}
    </div>
</div>

<!--{{templateTest( getActiveDeviceContainersList() )}}-->

<div class="table">
    <div class="table-header" [ngClass]="{
                      'count-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT,
                      'page-price-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE
                      }">

        <div class="table-header-column">
            Anzahl
        </div>
        <div class="table-header-column">Artikel</div>
    </div>

    <div class="table-body" [ngClass]="{
                      'count-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT,
                      'page-price-layout': getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE
                      }" *ngIf="showTable()">

        <ng-container *ngFor="let deviceContainer of getActiveDeviceContainersList()">

            <div class="table-row">

                <div class="amount-column-cell">
                    <app-amount-input [(ngModel)]="deviceContainer.deviceAmount.amount" [showIcon]="false"
                        [name]="deviceContainer.id + '-amount_sotc'" disabled>
                    </app-amount-input>
                </div>

                <div class="column-article-cell">
                    <div class="label-container">
                        <app-product-label [orderItemContainer]="deviceContainer" [activateHover]="false">
                        </app-product-label>
                    </div>
                </div>

            </div>

            <!--            when itemToOrder contains supplies add also rows for each of them -->
            <ng-container
                *ngIf="getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT || getSupplyAcquisitionMode() === supplyAcquisitionTypeEnum.PURCHASE">
                <div class="table-row accessory"
                    *ngFor="let supplyContainer of getSupplyContainersList(deviceContainer)">
                    <div class="amount-column-cell">
                        <ng-container *ngIf="isPrintSmartSupplyAcquisitionType()">
                            <app-amount-input [(ngModel)]="supplyContainer.parentPrintSmartDedicatedSupplyAmount.amount"
                                [showIcon]="false" [name]="supplyContainer.id + '-PS-amount_sotc'" disabled>
                            </app-amount-input>
                        </ng-container>
                        <ng-container *ngIf="!isPrintSmartSupplyAcquisitionType()">
                            <app-amount-input
                                [(ngModel)]="supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount"
                                [showIcon]="false" [name]="supplyContainer.id + '-G-amount'" disabled>
                            </app-amount-input>
                        </ng-container>
                    </div>

                    <div class="column-article-cell">
                        <div class="label-container">
                            <app-product-label [orderItemContainer]="supplyContainer" [activateHover]="false">
                            </app-product-label>
                        </div>
                    </div>
                </div>
            </ng-container>

        </ng-container>


        <!--no parent supplies-->
        <ng-container *ngIf="!isPrintSmartSupplyAcquisitionType() && model?.requestedGeneralNoCategorisedSupplyContainers?.length">
            <div class="table-row category">
                <div class="no-parent-title">
                    <div>Verbrauchsmaterialien ohne Geräte</div>
                </div>
            </div>

            <div class="table-row supply supply-no-parrent"
                *ngFor="let supplyContainer of model.requestedGeneralNoCategorisedSupplyContainers">

                <div class="amount-column-cell">
                    <app-amount-input [(ngModel)]="supplyContainer.noParentGeneralSupplyAmount.amount"
                        [showIcon]="false" [incrementViaMouseWheel]="false" [name]="supplyContainer.id + 'amount_sotc'"
                        disabled>
                    </app-amount-input>
                </div>

                <div class="column-article-cell">
                    <div class="label-container">
                        <app-product-label [orderItemContainer]="supplyContainer" [activateHover]="false">
                        </app-product-label>
                    </div>
                </div>



            </div>

        </ng-container>
    </div>

</div>

<div class="info" *ngIf="isPrintSmartSupplyAcquisitionType()">
    *Um ein zusätzliches Verbrauchsmaterialangebot für nicht MPS-fähige Geräte zu erhalten, erstellen Sie bitte eine
    separate Verbrauchsmaterial-Projektanfrage für die gewünschten Materialien.
</div>
